import { useEffect } from 'react';
import useAuthentication from 'hooks/useAuthentication';
import Logger from 'utilities/logger';

const usePendo = () => {
  const { user: currentUser } = useAuthentication();
  const logger = Logger('Pendo');

  useEffect(() => {
    if (currentUser && currentUser.uid && window.pendo) {
      logger.info(`Pendo Identify Logged User`);
      window.pendo.identify(currentUser.uid);
    }
  }, [currentUser]);
};

export default usePendo;
